  import React from 'react';
  import { Navigate } from 'react-router-dom';


  interface ProtectedRouteProps {
    children: React.ReactElement;
  }

  export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const token = localStorage.getItem('authToken');

    if (!token) {
      return <Navigate to="/" replace />;
    }

    return children;
  };

